module.exports = __webpack_public_path__ + "img/noSlots.3aafdba5.svg";